import { render, staticRenderFns } from "./OpportunityResolveBlockedModal.vue?vue&type=template&id=efc673ca&scoped=true&"
import script from "./OpportunityResolveBlockedModal.vue?vue&type=script&lang=js&"
export * from "./OpportunityResolveBlockedModal.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityResolveBlockedModal.vue?vue&type=style&index=0&id=efc673ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc673ca",
  null
  
)

export default component.exports